import React from "react";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import {
  delete_icon,
  edit_icon,
  green_icon,
  red_icon,
  user,
} from "../assets/imgs";

const CompanySitesAdd = ({
  groupUsers,
  setGroupPopup,
  type,
  handleGroupEdit,
  groupUserStatus,
}) => {
  //   console.log("groupUsers", groupUsers);

  const groupCat = {};

  for (let i of groupUsers) {
    let key = i.group_category;
    if (!groupCat[key]) {
      groupCat[key] = [];
    }
    groupCat[key].push(i);
  }

  //   console.log(groupCat, "groupCat");

  return (
    <div className="row d-flex flex-wrap align-items-start justify-content-between mt-3">
      <div className="col-md-4">
        {groupCat?.[3]?.length > 0 && (
          <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
            Group-1 ({groupCat?.[3]?.length})
          </p>
        )}
        <div className="w-100 ">
          {groupCat?.[3]?.map((item) => {
            return (
              <div
                key={item?.id}
                className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary"
              >
                <div className="d-flex ac-jb">
                  <div>
                    <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                      Name
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.name}
                    />
                  </div>
                  <img
                    src={
                      item?.profile_image?.name
                        ? URL.createObjectURL(item.profile_image)
                        : item?.profile_image
                        ? item.profile_image
                        : user
                    }
                    alt="preview"
                    className="user mb-1"
                    style={{
                      height: "70px",
                      width: "70px",
                      borderRadius: "35px",
                    }}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                    Email
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.email}
                  />
                  <div className="d-flex ac-js mt-2 gap-2">
                    <img
                      src={item?.is_email_verified ? green_icon : red_icon}
                      className="redImg"
                    />
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      {item?.is_email_verified ? "Verified" : "Not Verified"}
                    </p>
                  </div>
                </div>

                <div>
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                    Mobile
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.phone}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                    Group Category
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={
                      item?.group_category == 3
                        ? "Group User 1"
                        : item?.group_category == 4
                        ? "Group User 2"
                        : item?.group_category == 5
                        ? "Group User 3"
                        : ""
                    }
                  />
                </div>

                <div className="d-flex ac-jb gap-3">
                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Alert Notifications
                    </p>
                    {item?.notification_alert ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Beep Sound
                    </p>
                    {item?.beep_sound ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>
                </div>

                {(type == "edit" || type == "add") && (
                  <div className="d-flex ac-jb">
                    <button
                      onClick={() => groupUserStatus(item?.id)}
                      className={`${
                        item.status ? "active-btn" : "deactive-btn"
                      }`}
                    >
                      {item.status ? "Active" : "De-active"}
                    </button>

                    <div className="d-flex gap-2">
                      <button
                        className="cust-btn ms-3"
                        onClick={() => handleGroupEdit(item)}
                      >
                        <img src={edit_icon} alt="" className="edit-btn" />
                      </button>
                      {/* <button
                        onClick={() => setGroupPopup(item?.id)}
                        className="cust-btn "
                      >
                        <img src={delete_icon} alt="" className=" edit-btn " />
                      </button> */}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="col-md-4">
        {groupCat?.[4]?.length > 0 && (
          <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
            Group-2 ({groupCat?.[4]?.length})
          </p>
        )}
        <div className="w-100 ">
          {groupCat?.[4]?.map((item) => {
            return (
              <div
                key={item?.id}
                className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary"
              >
                <div className="d-flex ac-jb">
                  <div>
                    <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                      Name
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.name}
                    />
                  </div>
                  <img
                    src={
                      item?.profile_image?.name
                        ? URL.createObjectURL(item.profile_image)
                        : item?.profile_image
                        ? item.profile_image
                        : user
                    }
                    alt="preview"
                    className="user mb-1"
                    style={{
                      height: "70px",
                      width: "70px",
                      borderRadius: "35px",
                    }}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                    Email
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.email}
                  />
                  <div className="d-flex ac-js mt-2 gap-2">
                    <img
                      src={item?.is_email_verified ? green_icon : red_icon}
                      className="redImg"
                    />
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      {item?.is_email_verified ? "Verified" : "Not Verified"}
                    </p>
                  </div>
                </div>

                <div>
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                    Mobile
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.phone}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                    Group Category
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={
                      item?.group_category == 3
                        ? "Group User 1"
                        : item?.group_category == 4
                        ? "Group User 2"
                        : item?.group_category == 5
                        ? "Group User 3"
                        : ""
                    }
                  />
                </div>

                <div className="d-flex ac-jb gap-3">
                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Alert Notifications
                    </p>
                    {item?.notification_alert ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Beep Sound
                    </p>
                    {item?.beep_sound ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>
                </div>

                {(type == "edit" || type == "add") && (
                  <div className="d-flex ac-jb">
                    <button
                      onClick={() => setGroupPopup(item)}
                      className={`${
                        item.status ? "active-btn" : "deactive-btn"
                      }`}
                    >
                      {item.status ? "Active" : "De-active"}
                    </button>

                    <div className="d-flex gap-2">
                      <button
                        className="cust-btn ms-3"
                        onClick={() => handleGroupEdit(item)}
                      >
                        <img src={edit_icon} alt="" className="edit-btn" />
                      </button>
                      {/* <button
                        onClick={() => setGroupPopup(item?.id)}
                        className="cust-btn "
                      >
                        <img src={delete_icon} alt="" className=" edit-btn " />
                      </button> */}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="col-md-4">
        {groupCat?.[5]?.length > 0 && (
          <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
            Group-3 ({groupCat?.[5]?.length})
          </p>
        )}
        <div className="w-100 ">
          {groupCat?.[5]?.map((item) => {
            return (
              <div
                key={item?.id}
                className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary"
              >
                <div className="d-flex ac-jb">
                  <div>
                    <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                      Name
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.name}
                    />
                  </div>
                  <img
                    src={
                      item?.profile_image?.name
                        ? URL.createObjectURL(item.profile_image)
                        : item?.profile_image
                        ? item.profile_image
                        : user
                    }
                    alt="preview"
                    className="user mb-1"
                    style={{
                      height: "70px",
                      width: "70px",
                      borderRadius: "35px",
                    }}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                    Email
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.email}
                  />
                  <div className="d-flex ac-js mt-2 gap-2">
                    <img
                      src={item?.is_email_verified ? green_icon : red_icon}
                      className="redImg"
                    />
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      {item?.is_email_verified ? "Verified" : "Not Verified"}
                    </p>
                  </div>
                </div>

                <div>
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                    Mobile
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.phone}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                    Group Category
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={
                      item?.group_category == 3
                        ? "Group User 1"
                        : item?.group_category == 4
                        ? "Group User 2"
                        : item?.group_category == 5
                        ? "Group User 3"
                        : ""
                    }
                  />
                </div>

                <div className="d-flex ac-jb gap-3">
                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Alert Notifications
                    </p>
                    {item?.notification_alert ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Beep Sound
                    </p>
                    {item?.beep_sound ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>
                </div>

                {(type == "edit" || type == "add") && (
                  <div className="d-flex ac-jb">
                    <button
                      onClick={() => setGroupPopup(item)}
                      className={`${
                        item.status ? "active-btn" : "deactive-btn"
                      }`}
                    >
                      {item.status ? "Active" : "De-active"}
                    </button>

                    <div className="d-flex gap-2">
                      <button
                        className="cust-btn ms-3"
                        onClick={() => handleGroupEdit(item)}
                      >
                        <img src={edit_icon} alt="" className="edit-btn" />
                      </button>
                      {/* <button
                        onClick={() => setGroupPopup(item?.id)}
                        className="cust-btn "
                      >
                        <img src={delete_icon} alt="" className=" edit-btn " />
                      </button> */}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CompanySitesAdd;
